define('lq/conditions/operandEvaluator',[
    'jquery'
], function ($) {

    var yyyy_mm_dd = /^\d{4}[\/\-](0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])$/;

    var isDate = function (value) {
        return value != null &&
            (value.constructor === Date || (value.constructor === String && value.match(yyyy_mm_dd) != null));
    };

    var isString = function (value) {
        return typeof (value) === 'string';
    };

    var isBoolean = function (value) {
        return typeof (value) === 'boolean';
    };

    var secondValueShouldFallbackToEmptyString = function (first, second) {
        return isString(first) && second == null;
    };

    var makeBoolean = function (value) {
        value = value.toLowerCase();

        if (value === 'true')
            return true;

        if (value === 'false')
            return false;

        throw new Error('The value "' + value + '" cannot be converted to a boolean.');
    };

    var valueShouldBeConvertedToNull = function (theValue) {
        if (theValue === null) return false;

        return theValue === '' ||
            theValue === undefined

            // we used to do "==" instead of "===" when evaluating conditions
            // [] == "" will return true, but [] === "" won't => breaks compatibility
            ||
            (Array.isArray(theValue) && theValue.length === 0);
    };

    var evaluationHandlers = {
        '=': function (left, right) {
            if (valueShouldBeConvertedToNull(left)) left = null;
            if (valueShouldBeConvertedToNull(right)) right = null;

            return left === right;
        },
        '≠': function (left, right) {
            if (valueShouldBeConvertedToNull(left)) left = null;
            if (valueShouldBeConvertedToNull(right)) right = null;

            return left !== right;
        },
        '>': function (left, right) {
            return left > right;
        },
        '≥': function (left, right) {
            return left >= right;
        },
        '≤': function (left, right) {
            return left <= right;
        },
        '<': function (left, right) {
            return left < right;
        },
        'contains': function (left, right) {
            var leftString = String(left).toLowerCase();
            var rightString = String(right).toLowerCase();
            return leftString.indexOf(rightString) != -1;
        }
    };

    var OperandEvaluator = function (operand, piping) {
        $.extend(this, operand);
        this.piping = piping;
    };

    OperandEvaluator.prototype.evaluate = function (queryResults) {
        var left = this.getValue(this.leftValue, queryResults);
        var right = this.getValue(this.rightValue, queryResults);

        if (secondValueShouldFallbackToEmptyString(left, right)) {
            right = '';
        } else if (secondValueShouldFallbackToEmptyString(right, left)) {
            left = '';
        } else if ($.isNumeric(left) && $.isNumeric(right)) {
            left = Number(left);
            right = Number(right);
        } else if (isDate(left) && isDate(right)) {
            left = new Date(left).getTime();
            right = new Date(right).getTime();
        } else if (isBoolean(left) && isString(right)) {
            if (right)
                right = makeBoolean(right);
            else
                right = !left;
        } else if (isBoolean(right) && isString(left)) {
            if (left)
                left = makeBoolean(left);
            else
                left = !right;
        }

        var evaluator = evaluationHandlers[this.operator];
        return evaluator(left, right);
    };

    OperandEvaluator.prototype.getValue = function (operandValue, queryResults) {
        if (operandValue.viewModelKey)
            return this.piping.dropFactory
                .findDropByViewModelKey(operandValue.viewModelKey)
                .getValue();

        if (operandValue.parameter)
            return this.piping.parameters.getValue(operandValue.parameter);

        if (operandValue.dataSource)
            return queryResults[operandValue.dataSource.id][operandValue.dataSourceOutput];

        return operandValue.value;
    };

    return OperandEvaluator;
});
